<section class="centered-with-padding grid grid-cols-1 py-7 desk:grid-cols-[352px_auto] desk:gap-x-4 desk:pb-14">
  @if (data.testimonialQuote; as quote) {
    <div class="order-1 desk:row-span-2">
      <div class="flex h-fit flex-col items-start gap-y-2.5 rounded-2xl bg-anis px-6 py-8">
        <div class="text-black opacity-30">
          <app-svg [height]="50" [inline]="true" [width]="64" src="assets/icons/quote.svg" />
        </div>
        <div class="text-[20px] font-bold desk:text-[25px] desk:leading-none">{{ quote.text }}</div>
        <div>{{ quote.author }}</div>
      </div>
      <div class="hidden desk:block">
        <ng-container *ngTemplateOutlet="stickers" />
      </div>
    </div>
  }
  @if (data.content; as content) {
    <div
      [innerHtml]="content"
      class="prose order-2 py-5 prose-headings:mb-4 prose-headings:mt-2 prose-headings:font-title prose-headings:text-[25px] prose-headings:font-normal prose-headings:leading-none prose-p:leading-tight desk:pt-0 [&_.title-h2]:mb-4 [&_.title-h2]:mt-2 [&_.title-h2]:font-title [&_.title-h2]:text-[25px] [&_.title-h2]:font-normal [&_.title-h2]:leading-none [&_.title-h2]:text-black"
      handleHtmlLinks></div>
  }
  <div class="order-3 desk:order-4">
    @if (data.kitchenerMessage; as message) {
      <div class="flex flex-col gap-y-2.5 rounded-2xl bg-gray-light px-6 pb-12 pt-8 desk:px-8 desk:pb-8">
        <span class="text-[20px] font-bold">{{ message.title }}</span>
        <div [innerHtml]="message.text"></div>
        <div>{{ message.author }}</div>
      </div>
      @if (data.storeBanner; as banner) {
        <a
          [routerLink]="banner.url"
          class="mx-5 -mt-8 grid h-[108px] grid-cols-[auto_108px] gap-x-2.5 overflow-hidden rounded-2xl bg-purple pl-5 desk:mr-12 desk:w-[308px] desk:justify-self-end">
          <div class="flex flex-col justify-center gap-y-1">
            <span class="font-title-alt text-[20px]">{{ brandAndStore()[0] }}</span>
            <span class="font-title text-[25px]">{{ brandAndStore()[1] }}</span>
          </div>
          <div class="relative overflow-hidden rounded-2xl">
            @if (banner.image; as image) {
              <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks" />
            }
          </div>
        </a>
      }
    }
  </div>

  <div class="order-4 desk:hidden">
    <ng-container *ngTemplateOutlet="stickers" />
  </div>
</section>
<ng-template #stickers>
  @if (data.svgStickers; as stickers) {
    @let sticker_1 = stickers[0];
    @let sticker_2 = stickers[1];
    <div class="flex justify-center py-5">
      @if (sticker_1) {
        <app-svg [height]="113" [src]="sticker_1.svg" [width]="95" class="z-10 rotate-[-7deg]" />
      }
      @if (sticker_2) {
        <app-svg [height]="113" [src]="sticker_2.svg" [width]="95" class="-ml-2 mt-1 rotate-3" />
      }
    </div>
  }
</ng-template>
